import '../css/Footer.css'

function Footer() {
    return (
      <footer className="Header">
        <p>&copy;2026 Liz Alice John</p>
      </footer>
    )
}

export default Footer